import { render, staticRenderFns } from "./attendanceRecord.vue?vue&type=template&id=0fb7b3b0"
import script from "./attendanceRecord.vue?vue&type=script&lang=js"
export * from "./attendanceRecord.vue?vue&type=script&lang=js"
import style0 from "./attendanceRecord.vue?vue&type=style&index=0&id=0fb7b3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports